import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AvailabilityType } from 'src/app/shared/Models/SessionBookingDTO';
import { GuestService } from 'src/app/shared/services/guest.service';
import { Utilities } from 'src/app/shared/utilities/utilities';

@Component({
    selector: 'app-activity-slot-view',
    templateUrl: './activity-slot-view.component.html',
    styleUrls: ['./activity-slot-view.component.scss'],
    standalone: false
})
export class ActivitySlotViewComponent implements OnInit, OnChanges {

  @Input()
  SessionSlots;

  @Input()
  isMultiSlotSelection;

  @Input()
  MembershipId;

  @Input()
  AllocationTypes;

  @Output() slotClick: EventEmitter<any> = new EventEmitter<any>();

  intialized: boolean;
  constructor(private ts: TranslateService, private gs: GuestService) { }

  ngOnInit(): void {
    this.SessionSlots = this.SessionSlots.filter(session => session.Availability?.AvailabilityType != AvailabilityType.SelectionCriteriaNotMatched);
    this.slotStatusSet();
    this.initFormArray();
  }

  initFormArray() {
    this.intialized = true;
  }

  onSlotClick(event) {
    this.slotClick.emit(event);
    if(this.isMultiSlotSelection){
        this.disableOverlapingSessions();
    }
  }

  slotStatusSet() {
    this.SessionSlots.forEach(session => {
      let isAnyMember = false;
      isAnyMember = this.IsMember(session.Availability);
      session.disabled = session.disabled || !(session.Availability?.AvailabilityType === AvailabilityType.OpenToAll
        || (session.Availability?.AvailabilityType === AvailabilityType.OpenToSpecificMember
          && session.Availability?.AllocationTypeId == this.MembershipId && this.gs.selectedGuest.MemberActive || (isAnyMember && this.MembershipId)) || session.checked);
      if (session.Availability?.AllocationTypeId) {
        const { R, G, B, A } = this.AllocationTypes?.find(type => type.AllocationTypeId === session.Availability?.AllocationTypeId)?.Color;
        session['color'] = `rgba(${R}, ${G}, ${B}, ${A})`;
      }
    });
    this.disableOverlapingSessions();
  }
  IsMember(slot : any) : boolean{
    if(!slot || !this.gs.restaurantWidgetSettings$.value.AllocationMappings) return false;
    let allocationType = this.gs.restaurantWidgetSettings$.value.AllocationMappings;
    let isAnyMember = allocationType.find(type => type.AllocationTypeId === slot.AllocationTypeId)?.AllocationTypeName == 'AnyMembers';
    return isAnyMember;
  }
  
  disableOverlapingSessions(){
    var selectedSlots = this.SessionSlots.filter(slot => slot.checked);
    this.SessionSlots.forEach(session => {            
        if(!session.checked && this.isMultiSlotSelection){
            session.disabledOverlaped = this.isOverlap(selectedSlots, session);
        }
    });
}

isBetween(start, end, value){
    return value > start && value < end;
}

isOverlap(selectedSlots, slot): boolean{
    var slotStart = new Date(slot.Start);
    var slotEnd = new Date(slot.End);
    
    var intersectingSlots = selectedSlots.filter(selectedSlot => {
        let selectedSlotStart = new Date(selectedSlot.Start);
        let selectedSlotEnd = new Date(selectedSlot.End);
        
        if( // is Same Start Or End
            slotStart.getTime() === selectedSlotStart.getTime() || 
            slotEnd.getTime() === selectedSlotEnd.getTime() ||
            // is slot falls between selectedSlot
            this.isBetween(selectedSlotStart, selectedSlotEnd, slotStart) || 
            this.isBetween(selectedSlotStart, selectedSlotEnd, slotEnd) || 
            // is selectedSlot falls between slot
            this.isBetween(slotStart, slotEnd, selectedSlotStart) || 
            this.isBetween(slotStart, slotEnd, selectedSlotEnd)){ 
            return true;
        }
        
        return false;
    });
    return intersectingSlots.length;
}

  ngOnChanges(changes: SimpleChanges) {
    this.slotStatusSet();
  }


}
